










import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import reportModule from '@/store/modules/common/report.module';
import VHeaderItem from '@/components/report/item/VHeaderItem.vue';
import Mixin from '@/mixin';
import reportViewModel from '@/views/mastercoach/reportViewModel';

@Component({
  name: 'ReportDetail',
  components: { VHeaderItem }
})
export default class ReportDetail extends Mixin {
  public reportData: any[] = [];

  get score() {
    return this.reportData['coachingSuccessIndex(CSI)Score'];
  }

  mounted() {
    reportViewModel.loadReportParams()
    reportModule
      .loadReport({
        companyName: reportViewModel.company,
        fromDate: window.sessionStorage.getItem('REPORT_FROM_DATE') || reportViewModel.startDate,
        toDate: window.sessionStorage.getItem('REPORT_TO_DATE') || reportViewModel.endDate,
        department: reportViewModel.department,
        tz: Intl.DateTimeFormat().resolvedOptions().timeZone
      })
      .then(() => (this.reportData = reportModule.reportData));
  }

  destroyed() {
    reportViewModel.clean();
  }
}
